/*
  Values taken from Bank of Brands (https://natwest.frontify.com/)
*/

const THEMES = {
  nw: {
    name: 'zb-natwest-nonpersonal-standard',
    bodyClassName: 'zb-natwest-nonpersonal-standard-theme',
    favicon: '/assets/images/favicons/favicon-natwest.png',
  },
  rbs: {
    name: 'zb-rbs-nonpersonal-standard',
    bodyClassName: 'zb-rbs-nonpersonal-standard-theme',
    favicon: '/assets/images/favicons/favicon-rbs.png',
  },
  natwesti: {
    name: 'zb-natwesti-standard',
    bodyClassName: 'zb-natwesti-standard-theme',
    favicon: '/assets/images/favicons/favicon-natwest.png',
  },
  ubn: {
    name: 'zb-ulsterbank-standard',
    bodyClassName: 'zb-ulsterbank-standard-theme',
    favicon: '/assets/images/favicons/favicon-rbs.png',
  },
};

export default THEMES;
